export const CUSTOMER_CANCELLATION_REASONS = [
    { value: 'changed_circumstances', label: 'My situation has changed' },
    { value: 'ordered_wrong_item', label: 'I ordered the wrong item' },
    { value: 'found_better_price', label: 'I found a better price elsewhere' },
    { value: 'delivery_too_slow', label: 'Delivery is taking too long' },
    { value: 'no_longer_needed', label: 'I no longer need this' },
    { value: 'other', label: 'Other' },
];

export const STAFF_CANCELLATION_REASONS = [
    { value: 'customer_request', label: 'Customer requested' },
    { value: 'out_of_stock', label: 'Item out of stock' },
    { value: 'payment_issue', label: 'Payment issue' },
    { value: 'address_issue', label: 'Delivery address problem' },
    { value: 'duplicate_order', label: 'Duplicate order' },
    { value: 'fraud_suspicion', label: 'Suspected fraud' },
    { value: 'other', label: 'Other' },
];